import {combineReducers} from 'redux'
import {all} from 'redux-saga/effects'

import AuditTrailRedux from 'src/app/modules/audit-trail/redux/audit-redux'
import AuthRedux from 'src/app/modules/auth/redux/AuthRedux'
import LocalizationRedux from 'src/app/plugins/i18n/localization-redux'

export const rootReducer = () =>
  combineReducers({
    auth: AuthRedux.reducer(),
    audit: AuditTrailRedux.reducer,
    localization: LocalizationRedux.reducer(),
  })

export type RootState = ReturnType<ReturnType<typeof rootReducer>>

export function* rootSaga() {
  yield all([AuthRedux.saga()])
}
